import type { IMaintenanceType, IMaintenanceTypeForm } from '@/interfaces'
import Base from '../Base'
import type { AssetType } from '@/enum'

class MaintenanceTypeForm extends Base implements IMaintenanceTypeForm {
  title?: string
  description?: string
  assetType?: AssetType
  workHours?: number

  constructor(serviceTask?: IMaintenanceType) {
    super(serviceTask)
    this.title = serviceTask?.title
    this.assetType = serviceTask?.assetType
    this.description = serviceTask?.description
    this.workHours = serviceTask?.workHours
  }
}

export default MaintenanceTypeForm
